import styled from '@emotion/styled';

export const Date = styled('p')(({ theme }) => ({
  color: `${theme.colors.gray.medium}`,
  fontSize: '1.3rem',
  lineHeight: '1.8rem',
}));
